import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { superAdminDelete, superAdminGet, superAdminPost, superAdminPut } from './api';

export interface SuperAdminPostcode {
  id: string;
  postcode?: string;
  postcodeNoSpaces?: string;
  region?: string;
  point?: {
    lat?: number;
    lng?: number;
    coordinates?: number[];
    [key: string]: any;
  };
  [key: string]: any;
}

export interface SuperAdminPostcodeSaveData {
  postcode: string;
  region?: string;
  point: {
    lat: number;
    lng: number;
  };
}

export interface SuperAdminPostcodesFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

const DEFAULT_FILTER: SuperAdminPostcodesFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'postcodeNoSpaces ASC'
};

function buildFilter(filter: SuperAdminPostcodesFilter = DEFAULT_FILTER): SuperAdminPostcodesFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminPostcodes(
  filter: SuperAdminPostcodesFilter = DEFAULT_FILTER
): Promise<SuperAdminPostcode[]> {
  return superAdminGet<SuperAdminPostcode[]>('/postcodes', {
    params: {
      filter: buildFilter(filter)
    }
  });
}

export function getAllSuperAdminPostcodes(where?: any): Promise<SuperAdminPostcode[]> {
  return superAdminGet<SuperAdminPostcode[]>('/postcodes', {
    params: {
      filter: {
        where: where || {},
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminPostcodesCount(where?: any): Promise<Count> {
  const config =
    typeof where !== 'undefined'
      ? {
          params: {
            filter: {
              where
            }
          }
        }
      : {};

  return superAdminGet<Count>('/postcodes/count', config);
}

export function getSuperAdminPostcode(postcodeId: string): Promise<SuperAdminPostcode> {
  return superAdminGet<SuperAdminPostcode>(`/postcodes/${postcodeId}`);
}

export function createSuperAdminPostcode(data: SuperAdminPostcodeSaveData): Promise<SuperAdminPostcode> {
  return superAdminPost<SuperAdminPostcode>('/postcodes', data);
}

export function updateSuperAdminPostcode(
  postcodeId: string,
  data: SuperAdminPostcodeSaveData
): Promise<SuperAdminPostcode> {
  return superAdminPut<SuperAdminPostcode>(`/postcodes/${postcodeId}`, data);
}

export function deleteSuperAdminPostcode(postcodeId: string): Promise<void> {
  return superAdminDelete<void>(`/postcodes/${postcodeId}`);
}
